export function loginDestination(user, from) {
  if (user?.role === "administrator") {
    return typeof from === "string" && from.startsWith("/admin/") ? from : "/admin/moderation";
  }
  return typeof from === "string" && from.startsWith("/app/") ? from : "/app/profile";
}

export function adminPhotoUrl(url) {
  if (!url) return undefined;
  return new URL(url, process.env.REACT_APP_BACKEND_URL).href;
}
